import { render, staticRenderFns } from "./Legacy.vue?vue&type=template&id=75ad0b05"
import script from "./Legacy.vue?vue&type=script&lang=js"
export * from "./Legacy.vue?vue&type=script&lang=js"
import style0 from "./Legacy.vue?vue&type=style&index=0&id=75ad0b05&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports